module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_inkminkm.69b64fb9527b8044165b526fe06a7469.png";